export const GLOBAL = {
    MODULE: 'global',
};
export const EVENTS = {
    MODULE_LOADED: 'global.module-loaded',
    SHOW_NOTIFICATION: 'show-notification',
    SHOW_MESSAGE: 'show-message',

    MAP_RELOAD: 'map.reload',
    MAP_REFRESH: 'map.refresh',
    SELECT_FEATURE: 'map.select-feature',
    UNSELECT_FEATURE: 'map.unselect-feature',
    UPDATE_FEATURE: 'map.update-feature',
    HIGHLIGHT_FEATURE: 'map.highlight-feature',
    SHOW_MODAL_NEW_FEATURE: 'map.new-feature-show-modal',
    INITIALIZE_NEW_FEATURE: 'map.new-feature-initialize',
    FINISHED_NEW_FEATURE: 'map.new-feature-finished',
    CANCELED_NEW_FEATURE: 'map.new-feature-canceled',
};

export const MENU = {
    GROUP_PROPERTY: '_is_group',
}